import { useContext } from 'react';

import { APIContext } from '../APIProvider';

// Use this higher-order component to get access to the APIService singleton with access token
// It will pass the APIService (with token and user info) as props to the wrapped component whenever it renders

/**
 * @param WrappedComponent - The component you want to pass the apiService singleton as props
 * @returns - Component with apiService as props
 */
function withAPIService(WrappedComponent) {
  function HOC(props) {
    const { apiService } = useContext(APIContext);
    return <WrappedComponent {...props} apiService={apiService} />;
  }

  return HOC;
}

export default withAPIService;
